<template>
  <div v-if="variant" class="alert-header" :class="'variant-' + variant">
    <v-container class="d-flex align-center justify-space-between px-1">
      <div class="alert-header-content d-flex align-center">
        <v-icon
          class="alert-header-content-icon mr-3"
          :color="
            variant == 'warning' ? 'orange' : variant == 'danger' ? 'red' : ''
          "
          size="24"
        >
          $alertwarning
        </v-icon>
        <div v-if="variant == 'warning'" class="alert-header-content-text">
          {{ $t("general.trialExpires") }}
          <span class="font-weight-bold"> {{ trialExpiryAt }}. </span>
          {{
            $t(
              "general.trialUpgradePlan"
            )
          }}
        </div>
        <div v-else-if="variant == 'danger'" class="alert-header-content-text">
          <span class="font-weight-bold">
            {{ $t("general.trialExpired") }}
          </span>
          {{
            $t(
              "general.trialExpiredUpgradePlan"
            )
          }}
        </div>
      </div>
      <div class="alert-header-actions">
        <v-btn
          v-if="trialUpgradeUrl"
          class="ml-4"
          :href="trialUpgradeUrl"
          target="_blank"
          small
          elevation="0"
          :color="
            variant == 'warning' ? 'orange' : variant == 'danger' ? 'red' : ''
          "
        >
          <span class="white--text">{{ $t("general.upgradeNow") }}</span>
        </v-btn>
      </div>
    </v-container>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {};
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
    trialService() {
      if (!this.$store.state.services.data) {
        return null;
      }
      return this.$store.state.services.getTrialService();
    },
    variant() {
      if (!this.trialService?.is_trial) {
        return null;
      }
      if (moment(this.trialService.trial_expiry_at).isBefore(moment())) {
        return "danger";
      }
      return "warning";
    },
    trialExpiryAt() {
      if (this.trialService?.is_trial) {
        moment.locale(this.language);
        return moment(this.trialService.trial_expiry_at).fromNow();
      }
      return "";
    },
    trialUpgradeUrl() {
      if (this.trialService?.plan_upgrade_link) {
        return this.trialService.plan_upgrade_link;
      }
      return "";
    },
  },
};
</script>